import { useEffect, useState } from "react";
import FlatList from 'flatlist-react';
import { query, collection, onSnapshot, orderBy, where, doc, getDoc, limit, startAt, startAfter, getDocs } from "firebase/firestore";
import { db } from "../../../../../globals/firebase";
import { w2popup } from 'https://cdn.jsdelivr.net/gh/vitmalina/w2ui@master/dist/w2ui.es6.min.js'
import 'react-responsive-modal/styles.css';
import { publicUser } from "../../../../../globals/route-names";
import { NavLink, useNavigate } from "react-router-dom";
import { BsJournalRichtext } from "react-icons/bs";
import { formatDistance, setDefaultOptions } from 'date-fns'
import { FiDownload } from "react-icons/fi";
import { TfiFullscreen } from "react-icons/tfi";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTranslation } from "react-i18next";
import { pt } from 'date-fns/locale'


function SectionJobsListRootImages() {

    const [listadeimages, setlistadeimages] = useState([])
    const [user, setuser] = useState(null)
    const [hasMoreItems, sethasMoreItems] = useState(false)
    const [Offset, setOffset] = useState(null)

    const { t, i18n } = useTranslation()


    useEffect(() => {
        setuser(JSON.parse(localStorage.getItem("user")))
        setfirst()



        if (i18n.language == "pt-BR" || i18n.language == "pt") {
            setDefaultOptions({ locale: pt })
        }



    }, [])

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    const setfirst = async () => {
        const getfirst = query(collection(db, "wpm_images"), where("public", "==", true), orderBy("datainsert", "desc"), limit(5))
        const documentSnapshots = await getDocs(getfirst);
        const first = documentSnapshots.docs[0];
        setOffset(first)
        loadchanges(first, "first")

    }

    const showBlank = () => {
        if (listadeimages.length === 0) {
            return <div>Loading list...</div>
        }

        return <div>No items for this list</div>
    }

    const saveAs = (url) => {
        var link = document.createElement('a');
        link.href = url;
        link.download = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const fullscreen = (url) => {

        w2popup.open({
            modal: true,
            openMaximized: true,
            color: '#000',
            body: '<img src="' + url + '" style="height:100%;display: block;margin: auto">',
            showClose: true,
            actions: {
                Ok(event) {
                    w2popup.close()
                }
            }
        })

        //w2popup.max();

    }


    const loadchanges = async (docfrom, start) => {


        setlistadeimages([])


        let q = null
        if (start === "first") {
            q = query(collection(db, "wpm_images"), where("public", "==", true), orderBy("datainsert", "desc"), startAt(docfrom), limit(30));
        }


        if (start === "last") {
            q = query(collection(db, "wpm_images"), where("public", "==", true), orderBy("datainsert", "desc"), startAfter(docfrom), limit(30));
        }

        onSnapshot(q, async (querySnapshot) => {
            const newTodos = [...listadeimages];
            querySnapshot.forEach(async (docu) => {

                const docRef = doc(db, "wpm_prompts", docu.data().promptid)
                const promptdoc = await getDoc(docRef);


                const docinsert = {
                    id: docu.id,
                    imageurl: docu.data().imageurl,
                    promptid: docu.data().promptid,
                    userid: docu.data().userid,
                    username: docu.data().username,
                    dateinsert: docu.data().datainsert,
                    prompttext: promptdoc.data() != undefined ? promptdoc.data().prompttext : ""
                }


                //console.log(docinsert)

                newTodos.push(docinsert);
                setOffset(docu)
            });
            setlistadeimages(newTodos);
            sethasMoreItems(listadeimages.length < querySnapshot.docs.length)

        })


    }

    return (
        <>
            <div>
                <div style={{ display: "flex", paddingLeft: "20px", flexDirection: "column", width: "100%" }}>
                    <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                        <div style={{ paddingRight: "20px", fontWeight: "bold", fontSize: "14px" }}>
                            {listadeimages.length} {t('imagesroot.publicimages')}

                        </div>

                        {user == null || user == undefined ?

                            <div>
                                <a className="site-button" data-bs-toggle="modal" href="#sign_up_popup2" role="button">
                                    <i className="feather-log-in" />
                                    {t('imagesroot.publicimages')}
                                </a>
                            </div>

                            :

                            <div>

                                <NavLink to={publicUser.jobs.LIST} className="twm-job-title">
                                    <span className="site-button">
                                        <BsJournalRichtext color="white" size="15" />
                                        {t("imagesroot.createprompt")}

                                    </span>
                                </NavLink>

                            </div>

                        }
                    </div>
                    <div style={{ width: "100%" }}>
                        <FlatList
                            list={listadeimages}
                            displayGrid
                            minColumnWidth="300px"
                            scrollToTop
                            gridGap="5px"
                            renderItem={(doca, idx) =>

                                <div key={idx} className="masonry-wrap row d-flex">
                                    {/*Block one*/}
                                    <div className="row">
                                        {/*Block one*/}
                                        <div className="col-md-12">
                                            {doca.imageurl != "" ?
                                                <div style={{ paddingTop: "5px" }}>
                                                    <div className="card bg-light mb-3">

                                                        <div style={{ padding: "5px", borderRadius: "15px" }} className="card-body">
                                                            {doca.username != null && doca.username != "" ?
                                                                <span style={{ fontSize: "9px", fontWeight: "bold" }}>{t("imagesroot.by")} {doca.username} - {(formatDistance(doca.dateinsert, Date.now(), { addSuffix: true }))}</span>
                                                                :
                                                                <span style={{ fontSize: "9px", fontWeight: "bold" }}>{(formatDistance(doca.dateinsert, Date.now(), { addSuffix: true }))}</span>
                                                            }

                                                        </div>
                                                        <div style={{ padding: "5px", borderRadius: "15px" }} className="card-body">
                                                            <LazyLoadImage src={doca.imageurl} />
                                                        </div>

                                                        <div style={{ padding: "5px", borderRadius: "15px" }} className="card-body">
                                                            <span style={{ fontSize: "9px" }}>
                                                                "{doca.prompttext}"
                                                            </span>
                                                        </div>

                                                        <div className="card-footer">

                                                            <div style={{ fontSize: "10px", display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>
                                                                <button style={{ fontSize: "10px" }} type="submit" className="site-button" onClick={(e) => { saveAs(doca.imageurl) }}>
                                                                    <FiDownload color="white" size="15" />
                                                                    Download</button>
                                                                <button style={{ fontSize: "10px" }} type="submit" className="site-button" onClick={(e) => { fullscreen(doca.imageurl) }}>
                                                                    <TfiFullscreen color="white" size="15" />
                                                                    {t("imagesroot.fullscreen")}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>

                                                    </div>
                                                </div>

                                                :

                                                ""
                                            }
                                        </div>

                                    </div>
                                </div>



                            }
                        />

                    </div>
                    {hasMoreItems == false ?
                        <div style={{ padding: "20px", alignSelf: "center", width: "200px" }}>
                            <button className="site-button" onClick={(e) => { e.preventDefault(); loadchanges(Offset, "last") }}>{t("imagesroot.loadmore")}</button>
                        </div>

                        : ""}
                </div>
            </div >
        </>
    )
}

export default SectionJobsListRootImages;